import { DIETARY_OPTIONS } from '../constants/listingOptions';

/**
 * Listing form fields shared byte-for-byte between createListing and
 * editListing. Exported individually (rather than as one block) because
 * the two pages interleave them differently with their own fields
 * (cuisine, address, date/time, max guests, booking cutoff).
 */
export const TitleField = ({ value, error, onChange }) => (
  <div className="form-group">
    <label htmlFor="title">Title</label>
    <input
      type="text"
      id="title"
      name="title"
      value={value}
      onChange={onChange}
      maxLength={100}
      placeholder="Give your meal a catchy title"
    />
    <div className="char-count">{value.length}/100</div>
    {error && <span className="field-error">{error}</span>}
  </div>
);

export const DescriptionField = ({ value, error, onChange }) => (
  <div className="form-group">
    <label htmlFor="description">Description</label>
    <textarea
      id="description"
      name="description"
      value={value}
      onChange={onChange}
      maxLength={500}
      rows={4}
      placeholder="Describe your meal experience"
    />
    <div className="char-count">{value.length}/500</div>
    {error && <span className="field-error">{error}</span>}
  </div>
);

export const MenuField = ({ value, error, onChange }) => (
  <div className="form-group">
    <label htmlFor="menu">Menu <span className="optional-label">(Optional)</span></label>
    <textarea
      id="menu"
      name="menu"
      value={value}
      onChange={onChange}
      maxLength={500}
      rows={4}
      placeholder="List the dishes you'll be serving"
    />
    <div className="char-count">{value.length}/500</div>
    {error && <span className="field-error">{error}</span>}
  </div>
);

export const DietaryField = ({ selected, onToggle }) => (
  <div className="form-group">
    <label>Dietary Accommodations <span className="optional-label">(Optional)</span></label>
    <div className="checkbox-options">
      {DIETARY_OPTIONS.map(option => (
        <label key={option} className="checkbox-label">
          <input
            type="checkbox"
            checked={selected.includes(option)}
            onChange={() => onToggle(option)}
          />
          <span>{option}</span>
        </label>
      ))}
    </div>
  </div>
);

export const AlcoholField = ({ value, onChange }) => (
  <div className="form-group">
    <label>Alcohol</label>
    <div className="radio-options">
      <label className="radio-label">
        <input
          type="radio"
          name="alcoholOption"
          value="none"
          checked={value === 'none'}
          onChange={onChange}
        />
        <span>No Alcohol</span>
      </label>
      <label className="radio-label">
        <input
          type="radio"
          name="alcoholOption"
          value="included"
          checked={value === 'included'}
          onChange={onChange}
        />
        <span>Alcohol Included</span>
      </label>
      <label className="radio-label">
        <input
          type="radio"
          name="alcoholOption"
          value="byob"
          checked={value === 'byob'}
          onChange={onChange}
        />
        <span>BYOB</span>
      </label>
    </div>
  </div>
);

export const SpecialNotesField = ({ value, onChange }) => (
  <div className="form-group">
    <label htmlFor="specialNotes">Special Notes <span className="optional-label">(Optional)</span></label>
    <textarea
      id="specialNotes"
      name="specialNotes"
      value={value}
      onChange={onChange}
      rows={3}
      placeholder="Any additional information for guests"
    />
  </div>
);
